import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import {
  GetAllPrecalibrationsQuery,
  GetAllPrecalibrationsQueryVariables,
} from "types/graphql-schema";

import getAllPrecalibrationsQuery from "@apps/reporting/graphql/get-all-precalibrations-query";
import { assertEdgesNonNull } from "@helpers/helpers";

const usePrecalibrationData = ({
  complianceProgramId,
  templateId,
  skip,
}: {
  complianceProgramId: number;
  templateId: number;
  skip?: boolean;
}) => {
  const { data, loading } = useQuery<
    GetAllPrecalibrationsQuery,
    GetAllPrecalibrationsQueryVariables
  >(getAllPrecalibrationsQuery, {
    variables: {
      complianceProgramId,
      templateId,
    },
    skip,
    fetchPolicy: "cache-and-network",
  });

  const calibrations = useMemo(
    () =>
      data?.assessmentCalibrations
        ? assertEdgesNonNull(data.assessmentCalibrations)
        : [],
    [data],
  );

  return {
    precalibrationData: calibrations,
    loading,
  };
};

export default usePrecalibrationData;
